import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SettingsRoutingModule } from './settings-routing.module';
import { SettingsComponent } from './settings.component';
import { ProfileComponent } from './profile/profile.component';
import { MatToolbar, MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';

import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { FilterAutocompleteComponent } from "@nucleus/ui-base";
import { PageHeaderComponent } from "@nucleus/ui-base";
import { FormErrorSummaryComponent } from "@nucleus/form-error-summary-ui";
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LibMyProfileComponent } from '@nucleus/user-ui';
import { SystemPropertyListComponent } from '@nucleus/system-property-ui';
import { NUCLEUS_USER_UI_PROVIDERS } from '../services/user-ui-adapters';
import { SystemPropertyComponent } from './system-property/system-property.component';

@NgModule({
  providers: [...NUCLEUS_USER_UI_PROVIDERS],
  declarations: [
    ProfileComponent,
    SettingsComponent,
    SystemPropertyComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    FormsModule,
    MatToolbarModule,
    MatToolbar,
    MatMenuModule,
    MatIconModule,
    MatTableModule,
    MatTabsModule,
    MatTreeModule,
    MatCardModule,
    MatButtonModule,
    MatChipsModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatListModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormField,
    MatLabel,
    MatInputModule,
    MatAccordion,
    MatExpansionModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTooltipModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    FilterAutocompleteComponent,
    PageHeaderComponent,
    FormErrorSummaryComponent,
    LibMyProfileComponent,
    MatSidenavModule,
    MatCheckboxModule,
    MatRadioModule,
    SystemPropertyListComponent,
    SettingsRoutingModule
  ],
  bootstrap: [SettingsComponent],
})
export class SettingsModule {}
